import { Product, Coat, ApplicationTechnique, Substrate } from './../model/model';
import { DataService } from './data.service';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { applySourceSpanToStatementIfNeeded } from '@angular/compiler/src/output/output_ast';

@Injectable({
  providedIn: 'root'
})
export class CoatService {

  ////////////////////////////////////////////////
  // Coats
  ///////////////////////////////////////////////
  private coat_api_endpoint = '/coat';
  private coat_full_api_url;
  public coats: Coat[] = []
  private coat_initialised = new BehaviorSubject(false);

  ////////////////////////////////////////////////
  // Application Technique
  ///////////////////////////////////////////////
  private applicationTechnique_api_endpoint = '/applicationtechnique';
  private applicationTechnique_full_api_url;
  public applicationTechniques: ApplicationTechnique[] = [];
  private applicationTechnique_initialised = new BehaviorSubject(false);

  public default_applicaitonTechnique: ApplicationTechnique;

  public lastRefresh;
  public initialised = new BehaviorSubject(false);

  constructor(public dataService: DataService) {
    //coats
    this.coat_full_api_url = dataService.getUrl() + this.coat_api_endpoint;

    //applicationTechnique
    this.applicationTechnique_full_api_url = dataService.getUrl() + this.applicationTechnique_api_endpoint;
  }

  getCoatById(id) {
    for (let coat of this.coats) {
      if (coat.id == id) {
        return coat;
      }
    }
  }

  getCoatsByTypeId(typeId:string){
    let values = [];

    if(this.coats){
      for(let coat of this.coats){
        if(coat.type == typeId){
          values.push(coat);
        }
      }
    }

    return values;
  }

  getApplicationTechniqueById(id) {
    for (let apptech of this.applicationTechniques) {
      if (apptech.id == id) {
        return apptech;
      }
    }
  }

  refreshData() {
    this.initialised.complete();
    this.initialised = new BehaviorSubject(false);
    this.coats = [];

    ////////////////////////////////////////////////
    // Application Technique
    ///////////////////////////////////////////////
    this.dataService.getRequest(this.applicationTechnique_full_api_url).subscribe(response => {
      if (response && response['data']) {
        for (let item of response['data']) {
          let appType: ApplicationTechnique = new ApplicationTechnique();
          appType.id = item['id'];
          appType.name = item['name'];
          appType.is_default = item['is_default'];

          //set default application technique
          if (appType.is_default) {
            this.default_applicaitonTechnique = appType;
          }

          this.applicationTechniques.push(appType);
        }

        //if not default is specified in the data, set the first value
        if (!this.default_applicaitonTechnique && this.applicationTechniques.length > 0) {
          this.default_applicaitonTechnique = this.applicationTechniques[0];
        }

        this.applicationTechnique_initialised.next(true);
      }
    });

    ////////////////////////////////////////////////
    // Coats
    ///////////////////////////////////////////////
    this.applicationTechnique_initialised.subscribe(state => {
      if (state) {
        this.dataService.getRequest(this.coat_full_api_url).subscribe(response => {
          if (response && response['data']) {
            for (let item of response['data']) {
              let coat: Coat = new Coat();
              coat.id = item['id'];
              coat.name = item['name'];
              coat.code = item['code'];
              coat.order = item['order'];
              coat.type = item['type'];
              coat.applicationTechniques = [];

              for (let apptype of item['application_techniques']) {
                coat.applicationTechniques.push(this.getApplicationTechniqueById(apptype));
              }

              this.coats.push(coat);
            }

            this.coat_initialised.next(true);
          }
        });
      }
    });



    this.coat_initialised.subscribe(coat_state => {
      if (coat_state) {
        this.applicationTechnique_initialised.subscribe(app_state => {
          if (app_state) {
            this.lastRefresh = new Date();
            this.initialised.next(true);
          }
        });
      }
    });
  }
}